<template>
  <div class="page-error">
    <div class="page-error__information">
      <div class="page-error__information__logo">
        <img src="https://assets-cdn.signable.co.uk/images/signable_cropped.svg" alt="Signable" v-if="!$store.state.logoURL" />
        <img :src="$store.state.logoURL" :alt="$store.state.clientInfo.company_name || $store.state.config.company_name" v-else />
      </div>
      <hr />
      <h1>{{ $t('error.somethingWentWrong') }}</h1>
      <h2>{{ $t('error.message', { errorMessage }) }}</h2>
      <p><i>{{ errorCode }}</i></p>
      <message type="info" iconName="info-circle" v-if="errorType === 'sender'">
        {{ $t('error.contactSender') }}
      </message>
      <message type="info" iconName="info-circle" v-else-if="errorType === 'service'">
        <i18n path="error.contactSignableMessage" tag="span">
          <a href="https://signable.co.uk/contact" target="_blank">{{ $t('error.contactSignableLink') }}</a>
        </i18n>
      </message>
      <hr />
      <div class="page-error__information__language">
        <icon name="language" width="20" height="20"></icon>
        <language-switcher></language-switcher>
      </div>
    </div>
  </div>
</template>

<script>
import Message from '@/components/Message'
import LanguageSwitcher from '@/components/LanguageSwitcher'

export default {
  name: 'page-error',
  components: {
    Message,
    LanguageSwitcher
  },
  props: {
    errorMessage: {
      type: String,
      required: true
    },
    errorCode: {
      type: [String, Number]
    }
  },
  computed: {
    errorType () {
      const code = this.errorCode.toString()
      if (code.startsWith('4')) {
        return 'sender'
      } else if (code.startsWith('5')) {
        return 'service'
      }

      return 'unknown'
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  $color-button-default: $color-cta-dark
  $color-button-default-hover: $color-cta
  $color-button-cta: $color-cta
  $color-button-cta-hover: $color-cta-dark
  $color-button-disabled: $signable-secondary-4-shade-3
  $color-button-disabled-dark: $signable-secondary-4-shade-1
  $color-button-inverted: #fff
  $color-button-inverted-dark: $color-grey-light
  .page-error
    &__information
      max-width: 800px
      background: white
      margin: 60px auto
      border: 1px solid $color-border
      padding: $spacing-large $spacing-base
      hr
        border: none
        border-bottom: 1px solid $color-border
        margin: 30px 0
      &__logo
        img
          width: 250px
          margin: 0 auto
      &__language
        svg
          vertical-align: middle
        select
          height: 26px
          width: 120px
</style>
